import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService, User } from '@empusa/empusa-core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MICROAPP_ACCESS, MICROAPP_NAME } from '../public-api';
// import { MICROAPP_ACCESS, MICROAPP_NAME } from '../lib/microapp-fittingout.module';

@Component({
  selector: 'microapp-fittingout',
  templateUrl: 'microapp-fittingout.home.component.html',
  styleUrls: ['microapp-fittingout.home.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class FittingoutComponent implements OnInit {
  siteName: string;
  loading: boolean;
  isAdmin: boolean;
  isSuperAdmin: boolean;
  isManagement: boolean;
  can_access: boolean = false;
  constructor(private translate: TranslateService, private auth: AuthenticationService,
    private _snackBar: MatSnackBar) {
  }

  ngOnInit(): void {
    this.can_access = this.auth.canUserExecute(MICROAPP_NAME, MICROAPP_ACCESS);
    this.loading = true;
    this.auth.loadCurrentUser().then((user: User) => {
      this.loading = false;
      this.siteName = user.sites[0].name;
      this.isManagement = this.auth.hasCurrentUserRole("MANAGEMENT");
      this.isSuperAdmin = this.auth.hasCurrentUserRole("SUPERADMIN");
      this.isAdmin = this.auth.hasCurrentUserRole("ADMIN");
    });
  }



}